import React, { useState, useEffect, useContext } from "react";
import classes from "./truckandtransporter.module.css";
import axios from "../../../../../../Axios";
import { Urls } from "../../../../../../Urls";
import Loader from "../../../../../Loader";
import { toast } from "react-toastify";
import { next_page, save_details_api, TransporterSuggest } from "../Utility";
import { Activity, currentRequestTimeStamp } from "../../../../../../Constants";
import { getProfileDetails } from "../../../../Utility";
import { UserApiContext } from "../../../../../../../src/Components/UserDetailsContext/UserDetailsContext"; // adjust path if different
import { MyCompanyProfileContext } from "../../../../../../MyCompanyProfileContext"; // optional if you want companySettingData
import { useMixPanelForTracking } from "../../../../../../utils/TrackMixPanel";

/**
 * Step 4
 * Component for displaying and reviewing truck and transporter details.
 */
const TruckandTransporter = ({
  step = 3,
  setStep = "",
  setPreviosStep = "",
  companyProfile = "",
  PreviosStep = 0,
  trucks = [],
  // settrucks='',
  excel_details = {},
  fetch_cleaning_details = "",
  fetch_saved_details = "",
  transporters = [],
  isBulkUpload,
  // settransporter=''
}) => {
  const [truckTypes, setTruckTypes] = useState([]);
  const [truck_details, setTruck_details] = useState([]);
  const [transporter_details, setTransporter_details] = useState([]);
  const [show, setShow] = useState(false);
  const [TransporterShow, setTransporterShow] = useState(false);
  // const [companyTrucks, setCompanyTrucks] = useState([])
  const { userDetails } = useContext(UserApiContext) || {}; // ensure context exists
  const { companySettingData } = useContext(MyCompanyProfileContext) || {}; // optional
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  // fetch excel details and current step
  useEffect(() => {
    if (
      excel_details &&
      excel_details.blob_url &&
      (PreviosStep === 0 || PreviosStep === 2)
    ) {
      fetch_cleaning_details(excel_details.blob_url, excel_details.excel_id);
    } else {
      fetch_saved_details(excel_details.excel_id);
    }
  }, [excel_details]);

  // Fetches and sets truck types.
  // useEffect(() => {
  //   (async () => {
  //     await getTruckTypes();
  //     // var companyTrucksNew = await getCompanyTruck()
  //     setShow(true);
  //     await getProfileDetails(
  //       companyProfile.domain_data.company_id,
  //       "truck_details",
  //       "company"
  //     )
  //       .then((res) => {
  //         var companyTrucksNew =
  //           res.data[0] &&
  //           res.data[0].truck_details &&
  //           res.data[0].truck_details.length > 0
  //             ? res.data[0].truck_details
  //             : [];
  //         var temp = [];
  //         for (var i = 0; i < trucks.length; i++) {
  //           var truck =
  //             companyTrucksNew && companyTrucksNew.length > 0
  //               ? companyTrucksNew.filter(
  //                   (tr) => tr.truck_type === trucks[i]["Truck"]
  //                 )
  //               : [];
  //           if (truck.length > 0) {
  //             var update_truck = trucks[i];
  //             update_truck["truck"] = truck[0];
  //             update_truck["label"] = truck[0]["truck_type"];
  //             update_truck["value"] = truck[0]["truck_type"];
  //             temp.push(update_truck);
  //           } else {
  //             if (trucks[i].type === "matched") {
  //               trucks[i].label = truck["Map"];
  //               trucks[i].value = truck["Map"];
  //             } else {
  //               trucks[i].label =
  //                 trucks[i]["Suggestion"] && trucks[i]["Suggestion"].length > 0
  //                   ? trucks[i]["Suggestion"][0]
  //                   : "";
  //               trucks[i].value =
  //                 trucks[i]["Suggestion"] && trucks[i]["Suggestion"].length > 0
  //                   ? trucks[i]["Suggestion"][0]
  //                   : "";
  //             }
  //             temp.push(trucks[i]);
  //           }
  //           if (i === trucks.length - 1) {
  //             setShow(false);
  //             var temp_trucktype = truckTypes;
  //             companyTrucksNew.map((truck) => {
  //               truck.label = truck.truck_type;
  //               truck.value = truck.truck_type;
  //               temp_trucktype.push(truck);
  //             });
  //             setTruckTypes(temp_trucktype);
  //             setTruck_details(temp);
  //           }
  //         }
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   })();

  //   // setTransporter_details(transporter)
  // }, [trucks]);

  useEffect(() => {
    (async () => {
      await getTruckTypes();
      setShow(true);
      await getProfileDetails(
        companyProfile.domain_data.company_id,
        "truck_details",
        "company"
      )
        .then((res) => {
          var companyTrucksNew =
            res.data[0] &&
            res.data[0].truck_details &&
            res.data[0].truck_details.length > 0
              ? res.data[0].truck_details
              : [];
          var temp = [];
          for (var i = 0; i < trucks.length; i++) {
            // 🔹 updated matching logic
            const typeMatch = truckTypes.find(
              (t) => t.value === trucks[i]["Truck"]
            );
            if (typeMatch) {
              var update_truck = { ...trucks[i] };
              update_truck["label"] = typeMatch.label;
              update_truck["value"] = typeMatch.value;
              temp.push(update_truck);
            } else {
              var truck =
                companyTrucksNew && companyTrucksNew.length > 0
                  ? companyTrucksNew.filter(
                      (tr) => tr.truck_type === trucks[i]["Truck"]
                    )
                  : [];
              if (truck.length > 0) {
                var update_truck = { ...trucks[i] };
                update_truck["truck"] = truck[0];
                update_truck["label"] = truck[0]["truck_type"];
                update_truck["value"] = truck[0]["truck_type"];
                temp.push(update_truck);
              } else {
                if (trucks[i].type === "matched") {
                  trucks[i].label = truck["Map"];
                  trucks[i].value = truck["Map"];
                } else {
                  trucks[i].label =
                    trucks[i]["Suggestion"] &&
                    trucks[i]["Suggestion"].length > 0
                      ? trucks[i]["Suggestion"][0]
                      : "";
                  trucks[i].value =
                    trucks[i]["Suggestion"] &&
                    trucks[i]["Suggestion"].length > 0
                      ? trucks[i]["Suggestion"][0]
                      : "";
                }
                temp.push(trucks[i]);
              }
            }
            if (i === trucks.length - 1) {
              setShow(false);
              var temp_trucktype = truckTypes;
              companyTrucksNew.map((truck) => {
                truck.label = truck.truck_type;
                truck.value = truck.truck_type;
                temp_trucktype.push(truck);
              });
              setTruckTypes(temp_trucktype);
              setTruck_details(temp);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    })();
  }, [trucks]);

  // Fetches and sets transporter details.
  useEffect(() => {
    (async () => {
      setTransporterShow(true);
      var transporter_list = [];
      for (var i = 0; i < transporters.length; i++) {
        await axios
          .post(
            `${Urls.Autocomplete.Get.getTransporterName}`,
            // await axios.post(`https://lorriapi.azurewebsites.net/api/transporter_data`,
            { transporter_name: transporters[i].Vendor }
          )
          .then((res) => {
            transporters[i].transporter =
              res.data.transporter_data && res.data.transporter_data.length > 0
                ? res.data.transporter_data[0]
                : {};
            transporter_list.push(transporters[i]);
            if (i === transporters.length - 1) {
              setTransporter_details(transporter_list);
              setTransporterShow(false);
            }
          })
          .catch((e) => {
            setShow(false);
            console.log(e);
          });
      }
    })();
  }, [transporters]);

  /**
   * Fetches truck types from the server.
   * @returns {Promise<void>}
   */
  const getTruckTypes = async () => {
    await axios
      .get(`${Urls.Autocomplete.Get.getlist}?searchFields=truck`)
      .then((res) => {
        var trucks = truckTypes;
        res.data.map((item) => {
          if (
            item.name &&
            trucks.filter((truck) => truck.label === item.name).length === 0
          ) {
            trucks.push({ label: item.name, value: item.name });
          }
        });
        // setTruckTypes(res.data.map(item => {
        //     if (item.name)
        //         return { label: item.name, value: item.name }
        // }))
        setTruckTypes(trucks);
      })
      .catch((err) => {});
  };

  /**
   * Updates the transporter details based on the selected transporter.
   * @param {Object} e - selected transporter.
   * @param {number} index - index of the transporter in the list.
   */
  const setcurrenttransporter = (e, index) => {
    var temp = transporter_details.map((vender) => {
      if (vender.index === index) {
        vender.transporter = e;
      }
      return vender;
    });
    setTransporter_details(temp);
  };

  /**
   * Updates the truck details based on the selected truck type.
   * @param {string} value - The selected truck type value.
   * @param {Object} truck - The truck object to be updated.
   */
  const selectTruck = (value, truck) => {
    var temp = truck_details.map((t) => {
      if (t.index === truck.index) {
        t.label = value;
        t.value = value;
      }
      return t;
    });
    setTruck_details(temp);
  };

  /**
   * Validates the truck details.
   * @returns {boolean} - Returns `true` if all truck details are valid, otherwise `false`.
   */
  const check_truck = () => {
    for (var i = 0; i < truck_details.length; i++) {
      // console.log(truck_details[i])
      if (!truck_details[i].label || !truck_details[i].value) {
        // console.log('not found truck')
        return false;
      }
    }
    return true;
  };

  /**
   * Validates the transporter details.
   * @returns {boolean} - Returns `true` if all transporter details are valid, otherwise `false`.
   */
  const check_transporter = () => {
    for (var i = 0; i < transporter_details?.length; i++) {
      if (
        !transporter_details[i].transporter ||
        !transporter_details[i].transporter.transporter_name
      ) {
        // console.log('not found transporter')
        return false;
      }
    }
    return true;
  };

  /**
   * Saves the truck details.
   * @param {Array} trucks - The list of truck details to be saved.
   */
  const save_Trucks = (trucks) => {
    setShow(true);
    var trk_spell = [],
      trk_matched = [];
    trucks.map((truck) => {
      truck["user_input"] = "accepted";
      if (truck.type === "matched") {
        trk_matched.push(truck);
      }
      if (truck.type === "spell") {
        trk_spell.push(truck);
      }
    });
    if (trk_spell && trk_spell.length > 0) {
      var payload = {
        data: trk_spell,
        key: "trk_spell",
        excel_id: excel_details.excel_id,
      };
      save_details_api(payload)
        .then((res) => {
          setShow(false);
        })
        .catch((e) => console.log(e));
    }
    if (trk_matched && trk_matched.length > 0) {
      var payload = {
        data: trk_matched,
        key: "trk_matched",
        excel_id: excel_details.excel_id,
      };
      // console.log(payload)
      save_details_api(payload)
        .then((res) => {
          setShow(false);
          // toast.success('Trucks Matched Saved')
        })
        .catch((e) => console.log(e));
    }
  };

  /**
   * Saves the transporter details.
   * @param {Array} transporters - list of transporter details to be saved.
   */
  const save_Transporters = (transporters) => {
    setTransporterShow(true);
    var ven_matched = [],
      ven_spell = [];
    transporters.map((transporter) => {
      transporter["user_input"] = "accepted";
      if (transporter.type === "matched") {
        ven_matched.push(transporter);
      }
      if (transporter.type === "spell") {
        ven_spell.push(transporter);
      }
    });
    if (ven_spell && ven_spell.length > 0) {
      var payload = {
        data: ven_spell,
        key: "ven_spell",
        excel_id: excel_details.excel_id,
      };
      // console.log(payload)
      save_details_api(payload)
        .then((res) => {
          setTransporterShow(false);
          // save_details()
          // toast.success('Transporters Spell Saved')
        })
        .catch((e) => console.log(e));
    }
    if (ven_matched && ven_matched.length > 0) {
      var payload = {
        data: ven_matched,
        key: "ven_matched",
        excel_id: excel_details.excel_id,
      };
      // console.log(payload)
      save_details_api(payload)
        .then((res) => {
          setTransporterShow(false);
          // toast.success('Transporters matched saved')
        })
        .catch((e) => console.log(e));
    }
  };

  /**
   * Handles the navigation to the confirmation page.
   */
  const go_to_confirmpage = () => {
    Activity([
      {
        screen: "Company Profile",
        module: "Freight Master Upload Excel",
        user_activity: `Trucks and Transporter Screen: User clicked on Next Button`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
   TrackMixPanel({
    ModuleName: "masters",
    ScreenName: "freight master",
    Definition: "freight master poopup trucks and transporter screen: user has clicked on next button",
    Data: {
      ActivityLog: "TrucksAndTransporterScreenUserHasClickedOnNextButton"
    },
});
    if (!check_truck()) {
      toast.info("Please select the corresponding truck type from dropdown");
    } else if (!check_transporter()) {
      toast.info("Please select corresponding transporter from dropdown");
    } else {
      save_Trucks(truck_details);
      save_Transporters(transporter_details);
      next_page({
        data: "confirmlanes",
        excel_id: excel_details.excel_id,
        key: "page",
      });
      setStep(4);
    }
  };

  /**
   * Cancels the current process and returns to the previous state.
   */
  const cancelProcess = () => {
    if (window.confirm("Are you sure to cancel?")) {
      next_page({
        data: "completed",
        excel_id: excel_details.excel_id,
        key: "page",
      }); //Imp
      document.getElementById("close_contactus1").click();
      toast.success("Process Cancelled Successfully");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row" style={{ minHeight: isBulkUpload ? "55vh" : "" }}>
        <div className="col-md-6">
          <Loader show={show} />
          <h5 className="mb-3">Check Truck Types</h5>
          <div className="border">
            <div className="card-header">
              <div className="row">
                <div className="col-6">Unique Trucks</div>
                <div className="col-6">Check Truck Type</div>
              </div>
            </div>
            <div
              className="card-body"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              {truck_details && truck_details.length > 0 ? (
                truck_details.map((truck) => (
                  <div className="row mb-2" key={truck.index}>
                    <div className="col-6">{truck["Truck"]}</div>
                    <div className="col-6">
                      {/* <Select
                                options={truckTypes}
                                onChange={value => selectTruck(value)}
                                value={truck}
                                className={"Truck_type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                formatCreateLabel={() => ''}
                            /> */}
                      <select
                        className="form-control"
                        onChange={(e) => selectTruck(e.target.value, truck)}
                      >
                        <option disabled selected>
                          Please select
                        </option>
                        {truckTypes && truckTypes.length > 0
                          ? truckTypes.map((t) => {
                              return (
                                <option
                                  selected={
                                    t.value === truck.value ? true : false
                                  }
                                  key={t.value}
                                  value={t.value}
                                >
                                  {t.label}
                                </option>
                              );
                            })
                          : null}
                      </select>
                      {(!truck.label ||
                        !truck.value ||
                        truck.label === "" ||
                        truck.value === "") && (
                        <small className="text-danger">
                          Please Select Truck Type from dropdown
                        </small>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <span>No Trucks Found</span>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <Loader show={TransporterShow} />
          <h5 className="mb-3">Check Transporters</h5>
          <div className="border">
            <div className="card-header">
              <div className="row">
                <div className="col-6">Unique Transporters</div>
                <div className="col-6">Check Transporters</div>
              </div>
            </div>
            <div
              className="card-body"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              {transporter_details?.length > 0 ? (
                transporter_details.map((transporter) => (
                  <div className="row mb-2" key={transporter.index}>
                    <div className="col-6">{transporter["Vendor"]}</div>
                    <div
                      className={`col-6 ${classes["transporter_autocomplete"]}`}
                    >
                      <TransporterSuggest
                        transporter={transporter}
                        setcurrenttransporter={(e) =>
                          setcurrenttransporter(e, transporter.index)
                        }
                      />
                    </div>
                  </div>
                ))
              ) : (
                <span>No Transporters Found</span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div
          className="col-12 text-center d-flex justify-content-center"
          style={{ gap: "10px" }}
        >
          <button className="btn btn-danger me-2" onClick={cancelProcess}>
            Cancel
          </button>
          <button
            className="btn btn-primary me-2"
            onClick={() => {
              Activity([
                {
                  screen: "Company Profile",
                  module: "Freight Master Upload Excel",
                  user_activity: `Location Screen: User clicked on Previous Button`,
                  timestamp: currentRequestTimeStamp(),
                },
              ]);
              TrackMixPanel({
                ModuleName: "masters",
                ScreenName: "freight masters",
                Definition: "freight master popup location screen: user has clicked on previous button",
                Data: {
                  ActivityLog: "LocationScreenUserHasClickedOnPreviousButton"
                },
              });

              setPreviosStep(3);
              setStep(2);
            }}
          >
            Previous
          </button>
          <button
            className="btn btn-primary"
            disabled={TransporterShow || show}
            onClick={go_to_confirmpage}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
export default TruckandTransporter;
